import { TrustedAdvisor } from "aws-sdk";
import { WarningToast } from "../../Admin/Components/ToastComponent/RectHotToast";
import { Addition, Subtraction } from "../CalculationsWithDecimalValues";

const pinToStateMap = {
  11: "Delhi",
  12: "Haryana",
  13: "Haryana",
  14: "Punjab",
  15: "Punjab",
  16: "Chandigarh",
  17: "Himachal Pradesh",
  18: "Jammu and Kashmir",
  19: "Jammu and Kashmir",
  20: "Uttar Pradesh",
  21: "Uttar Pradesh",
  22: "Uttar Pradesh",
  23: "Uttar Pradesh",
  24: "Uttar Pradesh",
  25: "Uttar Pradesh",
  26: "Uttarakhand",
  27: "Uttarakhand",
  28: "Uttarakhand",
  30: "Rajasthan",
  31: "Rajasthan",
  32: "Rajasthan",
  33: "Rajasthan",
  34: "Rajasthan",
  36: "Gujarat",
  37: "Gujarat",
  38: "Gujarat",
  39: "Gujarat",
  396: "Dadra and Nagar Haveli and Daman and Diu",
  40: "Maharashtra",
  41: "Maharashtra",
  42: "Maharashtra",
  43: "Maharashtra",
  44: "Maharashtra",
  403: "Goa",
  45: "Madhya Pradesh",
  46: "Madhya Pradesh",
  47: "Madhya Pradesh",
  48: "Madhya Pradesh",
  49: "Chhattisgarh",
  50: "Telangana",
  51: "Andhra Pradesh",
  52: "Andhra Pradesh",
  53: "Andhra Pradesh",
  56: "Karnataka",
  57: "Karnataka",
  58: "Karnataka",
  59: "Karnataka",
  60: "Tamil Nadu",
  61: "Tamil Nadu",
  62: "Tamil Nadu",
  63: "Tamil Nadu",
  64: "Tamil Nadu",
  65: "Tamil Nadu",
  66: "Tamil Nadu",
  605: "Puducherry",
  67: "Kerala",
  68: "Kerala",
  69: "Kerala",
  682: "Lakshadweep",
  70: "West Bengal",
  71: "West Bengal",
  72: "West Bengal",
  73: "West Bengal",
  74: "West Bengal",
  737: "Sikkim",
  744: "Andaman and Nicobar Islands",
  75: "Odisha",
  76: "Odisha",
  77: "Odisha",
  78: "Assam",
  790: "Arunachal Pradesh",
  791: "Arunachal Pradesh",
  792: "Arunachal Pradesh",
  793: "Meghalaya",
  794: "Meghalaya",
  795: "Manipur",
  796: "Mizoram",
  797: "Nagaland",
  798: "Nagaland",
  799: "Tripura",
  80: "Bihar",
  81: "Bihar",
  82: "Bihar",
  83: "Bihar",
  84: "Bihar",
  85: "Bihar",
  86: "Jharkhand",
  90: "Army Postal Service",
  91: "Army Postal Service",
  92: "Army Postal Service",
  93: "Army Postal Service",
  94: "Army Postal Service",
  95: "Army Postal Service",
  96: "Army Postal Service",
  97: "Army Postal Service",
  98: "Army Postal Service",
  99: "Army Postal Service",
};
export function getGSTType(pinCode1, pinCode2) {
  console.log(pinCode1, pinCode2);
  const prefix1 = String(pinCode1).substring(0, 2);
  const prefix2 = String(pinCode2).substring(0, 2);
  const state1 = pinToStateMap[prefix1];
  const state2 = pinToStateMap[prefix2];

  if (state1 === "Unknown State" || state2 === "Unknown State") {
    return "Invalid PIN code";
  }

  if (state1 === state2) {
    return "GST";
  } else {
    return "IGST";
  }
}
export function getGSTTypeStatus(pinCode1, pinCode2) {
  console.log(pinCode1, pinCode2);
  const prefix1 = String(pinCode1).substring(0, 2);
  const prefix2 = String(pinCode2).substring(0, 2);
  const state1 = pinToStateMap[prefix1];
  const state2 = pinToStateMap[prefix2];

  if (state1 === "Unknown State" || state2 === "Unknown State") {
    return "Invalid PIN code";
  }

  if (state1 === state2) {
    return true;
  } else {
    return false;
  }
}

export function getGSTTypeFromGSTINPrefixStatus(gstin1, gstin2) {
  if (typeof gstin1 !== "string" || gstin1.length !== 15 || typeof gstin2 !== "string" || gstin2.length !== 15) {
    WarningToast(`Invalid GST No, Company GST:${gstin1.GST_Number} & Party GST:${gstin2.GST_Number}`);
    return "Invalid GSTIN";
  }

  const prefix1 = gstin1.substring(0, 2);
  const prefix2 = gstin2.substring(0, 2);
  console.log(prefix1, prefix2);
  if (prefix1 === prefix2) {
    return true;
  } else {
    return false;
  }
}
export function getGSTTypeFromGSTINPrefix(gstin1, gstin2) {
  console.log(gstin2, "gstin2");
  if (typeof gstin1 !== "string" || gstin1.length !== 15 || typeof gstin2 !== "string" || gstin2.length !== 15) {
    WarningToast(`Invalid GST No, Company GST:${gstin1?.GST_Number} & Party GST:${gstin2?.GST_Number}`);
    return "Invalid GSTIN";
  }

  const prefix1 = gstin1.substring(0, 2);
  const prefix2 = gstin2.substring(0, 2);

  if (prefix1 === prefix2) {
    return "GST";
  } else {
    return "IGST";
  }
}

export function getGSTTypeFromStatesStatus(state1, state2) {
  if (typeof state1 !== "string" || typeof state2 !== "string") {
    return "Invalid state names";
  }

  state1 = state1.trim().toLowerCase();
  state2 = state2.trim().toLowerCase();

  if (state1 === state2) {
    return true;
  } else {
    return false;
  }
}
export function getGSTTypeFromStates(state1, state2) {
  if (typeof state1 !== "string" || typeof state2 !== "string") {
    return "Invalid state names";
  }

  state1 = state1.trim().toLowerCase();
  state2 = state2.trim().toLowerCase();

  if (state1 === state2) {
    return "GST";
  } else {
    return "IGST";
  }
}

export const getInterOrIntraStateStatus = (PartyInfo) => {
  let company = sessionStorage.getItem("CompanyCode") && JSON.parse(sessionStorage.getItem("CompanyCode"));
  console.log(PartyInfo, company);
  if (PartyInfo && company) {
    if (PartyInfo.GST_Number) {
      return getGSTTypeFromGSTINPrefixStatus(company?.GST_Number, PartyInfo.GST_Number);
    } else if (PartyInfo.Business_Pincode || PartyInfo.Residential_Pincode) {
      const pincode = PartyInfo.Business_Pincode || PartyInfo.Residential_Pincode;
      return getGSTTypeStatus(company?.Pincode, pincode);
    } else if (PartyInfo.Business_State || PartyInfo.Residential_State) {
      const state = PartyInfo.Business_State || PartyInfo.Residential_State;
      return getGSTTypeFromStatesStatus(company?.State, state);
    } else {
      return true;
    }
  }
};

export const GetTax = (HSN, Party, alldata) => {
  let company = sessionStorage.getItem("CompanyCode") && JSON.parse(sessionStorage.getItem("CompanyCode"));
  console.log(company, HSN, Party, alldata);
  let Tax_Type = "";
  if (Party && company) {
    console.log(Party, company, "Bill_DetailsBill_Details");
    if (Party?.GST_Number) {
      Tax_Type = getGSTTypeFromGSTINPrefix(company?.GST_Number, Party?.GST_Number);
      console.log(Tax_Type, "Bill_DetailsBill_Details");
    } else if (Party?.Business_Pincode || Party?.Residential_Pincode) {
      const pincode = Party?.Business_Pincode || Party?.Residential_Pincode;
      Tax_Type = getGSTType(company?.Pincode, pincode);
      console.log(Tax_Type, "Bill_DetailsBill_Details");
    } else if (Party.Business_State || Party.Residential_State) {
      const state = Party.Business_State || Party.Residential_State;
      Tax_Type = getGSTTypeFromStates(company?.State, state);
      console.log(Tax_Type, "Bill_DetailsBill_Details");
    } else {
      Tax_Type = "GST";
    }
  }
  let Tax_Percentage = "";
  let Percentage;
  if (alldata?.RCM === "YES") {
    Tax_Percentage = HSN?.RCM?._id || HSN?.RCM;
    Percentage = HSN?.RCM?.Tax_Percentage;
  } else if (Party?.GST_Number) {
    Tax_Percentage = HSN?.FCM?._id || HSN?.FCM;
    Percentage = HSN?.FCM?.Tax_Percentage;
  } else {
    Tax_Percentage = HSN?.FCM_For_Unregister?._id || HSN?.FCM_For_Unregister;
    Percentage = HSN?.FCM_For_Unregister?.Tax_Percentage;
  }
  console.log(Tax_Type, Tax_Percentage);
  return { Tax_Type, Tax_Percentage, Percentage };
};

export const GetTaxFormula = async (
  Tax_Type,
  Tax_Percentage,
  RCM,
  Amount,
  GetInvoiceData,
  GetFormula,
  masterData,
  key = "",
  Is_MultiTax,
  InvoiceType,
  dispatch,
  Form_Key
) => {
  console.log(
    {
      Tax_Type,
      Tax_Percentage,
      RCM,
      Amount,
      GetInvoiceData,
      GetFormula,
      masterData,
      key,
      Is_MultiTax,
      InvoiceType,
      dispatch,
      Form_Key,
    },
    "gurehgirueghrieghreiughreiugrhe"
  );
  if (Tax_Type && Tax_Percentage && RCM) {
    let selectedExpenses = [];
    let Var = {
      Tax_Percentage,
      Tax_Type,
      RCM,
      Is_MultiTax: false,
      Invoice_Type: InvoiceType,
    };
    const { data: InvoiceData } = await GetInvoiceData({
      variables: Var,
    });
    console.log("Raw Invoice Data1:", InvoiceData);
    const InvoiceId = InvoiceData?.searchSalesInvoiceTypes[0]?._id;
    const TaxType = InvoiceData?.searchSalesInvoiceTypes[0]?.Tax_Type;
    const TaxPercentage = InvoiceData?.searchSalesInvoiceTypes[0]?.Tax_Percentage?.Tax_Percentage;
    if (!Is_MultiTax) {
      const { data: FormulaData } = await GetFormula({ variables: { id: InvoiceId } });
      selectedExpenses =
        FormulaData?.getLinkSalesExpense_With_Populate_Details_By_SalesInvoiceType[0]?.SalesExpense_Formulas || [];
    }

    let total = Amount?.value || 0;
    console.log(total);
    let results = [
      // {
      //   Name: "Taxable Amount",
      //   Amount: Amount?.value || 0,
      // },
    ];

    if (Is_MultiTax) {
      console.log("jiiiiiiiiiii");
      let variables = {
        Tax_Type,
        RCM,
        Is_MultiTax,
        Tax_Percentage: "",
      };
      const { data: invoiceData } = await GetInvoiceData({
        variables,
      });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: "Bills",
          data: { Invoice_Type: invoiceData?.searchSalesInvoiceTypes[0] },
        },
      });
      console.log("Raw Invoice Data2:", invoiceData);
      const invoiceId = invoiceData?.searchSalesInvoiceTypes[0]?._id;

      const { data: formulaData } = await GetFormula({ variables: { id: invoiceId } });
      console.log(formulaData);

      const allExpenses =
        formulaData?.getLinkSalesExpense_With_Populate_Details_By_SalesInvoiceType[0]?.SalesExpense_Formulas || [];
      let results = calculateExpenses(allExpenses, TaxType, TaxPercentage, Amount?.value);

      results.push({
        Name: "Total",
        Expense_Account: {
          Account_Name: masterData?.Party?.Search_Value,
          _id: masterData?.Party?.Account_Balance_Id,
        },
        Amount: total || 0,
        Transaction_Type: "Dr",
        Add_Deduct: "Deduct",
        Calculation_Type: "Total",
      });

      console.log(results);
      return results;
    } else {
      console.log(Form_Key);
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: "Bills",
          data: { Invoice_Type: InvoiceData?.searchSalesInvoiceTypes[0] },
        },
      });
      const roundOffExpenses = selectedExpenses.filter((el) => el.Calculation_Type === "Round Off");
      const regularExpenses = selectedExpenses.filter((el) => el.Calculation_Type !== "Round Off");
      console.log(regularExpenses);
      regularExpenses.forEach((el) => {
        console.log(el);
        const additionalAmount = (Number(el?.At_Percentage) / 100) * Number(Amount?.value) || 0;
        total = el?.Add_Deduct !== "None" ? Addition(Number(total), additionalAmount) : total;
        console.log(el, Number(el?.At_Percentage), additionalAmount, Number(total));

        results.push({
          Expense_Account: el?.Expense_Account,
          Account_ID: el?.Expense_Account?._id,
          Name: el.Name,
          Rate: el?.At_Percentage,
          row_id: key,
          Taxable_Amount: total,
          // Transaction_Type: "Dr",
          Transaction_Type: el?.Add_Deduct === "Add" ? "Cr" : el?.Add_Deduct === "Deduct" ? "Dr" : "",

          Amount: el?.Add_Deduct !== "None" ? (additionalAmount ? additionalAmount : 0) : 0,
          Add_Deduct: el?.Add_Deduct,
        });
      });
      console.log(results);

      // Process round off expenses last
      roundOffExpenses?.forEach((el) => {
        const amountNeededForRoundOff = Subtraction(Math.round(total), total);
        console.log(total, amountNeededForRoundOff);
        total = el?.Add_Deduct !== "None" ? Addition(total, Number(amountNeededForRoundOff)) : total; // Adjust the total by rounding off
        results.push({
          Expense_Account: el?.Expense_Account,
          Account_ID: el?.Expense_Account?._id,
          Name: el.Name,
          Rate: el?.At_Percentage,
          row_id: key,
          Taxable_Amount: total,
          // Transaction_Type: amountNeededForRoundOff < 0 ? "Cr" : "Dr",
          Transaction_Type:
            InvoiceType == "Sales"
              ? amountNeededForRoundOff < 0
                ? "Dr"
                : "Cr"
              : InvoiceType === "Purchase"
              ? amountNeededForRoundOff < 0
                ? "Cr"
                : "Dr"
              : "",
          Amount:
            el?.Add_Deduct !== "None"
              ? amountNeededForRoundOff < 0
                ? -1 * amountNeededForRoundOff
                : amountNeededForRoundOff
              : 0,
          Add_Deduct: el?.Add_Deduct,
          Calculation_Type: "Round Off",
        });
        console.log(`Round off adjustment: ${amountNeededForRoundOff}, New total: ${total}`);
      });
      console.log(results);

      // Add Total object
      results.push({
        Name: "Total",
        Expense_Account: {
          Account_Name: masterData?.Party?.Search_Value,
          _id: masterData?.Party?.Account_Balance_Id,
        },
        Amount: total || 0,
        Transaction_Type: InvoiceType == "Sales" ? "Dr" : "Cr",
        Add_Deduct: "Deduct",
        Calculation_Type: "Total",
      });

      return results;
    }
  }
  return [];
};

function calculateExpenses(allExpenses, Tax_Type, Tax_Percentage, Amount) {
  console.log(Amount);
  let total = Amount || 0;
  const results = [];

  const roundOffExpenses = allExpenses.filter((el) => el.Calculation_Type === "Round Off");
  const regularExpenses = allExpenses.filter((el) => el.Calculation_Type !== "Round Off");

  console.log("Calculating regular expenses...");
  regularExpenses.forEach((el, index) => {
    console.log(el, Tax_Percentage, Tax_Type);
    if (el.Tax_Percentage_Value === Tax_Percentage && Tax_Type === el.Apply_Type) {
      const additionalAmount = (Number(el?.At_Percentage) / 100) * Amount || 0;
      console.log(el, total, additionalAmount);
      total = el?.Add_Deduct !== "None" ? total + additionalAmount : total - additionalAmount;
      console.log(el, Number(el?.At_Percentage), additionalAmount, total);

      results.push({
        Expense_Account: el?.Expense_Account,
        Account_ID: el?.Expense_Account?._id,
        Name: el.Name,
        Rate: el?.At_Percentage,
        row_id: index,
        Taxable_Amount: total,
        Transaction_Type: el?.Add_Deduct === "Add" ? "Cr" : el?.Add_Deduct === "Deduct" ? "Dr" : "",
        Amount: el?.Add_Deduct === "Add" || el?.Add_Deduct === "Deduct" ? additionalAmount : 0,
        Add_Deduct: el?.Add_Deduct,
      });
    } else {
      // Include the expense without calculation
      results.push({
        Expense_Account: el?.Expense_Account,
        Account_ID: el?.Expense_Account?._id,
        Name: el.Name,
        Rate: el?.At_Percentage,
        row_id: index,
        Taxable_Amount: null, // No taxable amount since no calculation was done
        Transaction_Type: "",
        Amount: 0,
        Add_Deduct: el?.Add_Deduct,
      });
    }
  });

  console.log("Processing round off expenses...");
  roundOffExpenses.forEach((el, index) => {
    results.push({
      Expense_Account: el?.Expense_Account,
      Account_ID: el?.Expense_Account?._id,
      Name: el.Name,
      Rate: el?.At_Percentage,
      row_id: index,
      Taxable_Amount: total,
      Transaction_Type: "",
      //  amountNeededForRoundOff < 0 ? "Cr" : "Dr",
      Amount: 0,
      //  Math.abs(amountNeededForRoundOff),
      Add_Deduct: el?.Add_Deduct,
      Calculation_Type: "Round Off",
    });
  });
  console.log(results);
  return results;
}
